import { ref, onScopeDispose, getCurrentScope, type Ref } from 'vue'

const DESKTOP_QUERY = '(min-width: 1280px)'

export function useIsDesktop(): Ref<boolean> {
  if (typeof window === 'undefined') {
    return ref(false)
  }

  const mql = window.matchMedia(DESKTOP_QUERY)
  const isDesktop = ref(mql.matches)

  const handler = (e: MediaQueryListEvent) => {
    isDesktop.value = e.matches
  }

  mql.addEventListener('change', handler)

  if (getCurrentScope()) {
    onScopeDispose(() => {
      mql.removeEventListener('change', handler)
    })
  }

  return isDesktop
}
